import { gql } from '@apollo/client';
import type { HomeSpeed } from './Types';

import type { TimestampInMillis } from '@cobliteam/common-types';

import graphQLRequester from '../../request/GraphQLRequester';
import TimeZone from '../../request/Timezone';

export class GrahpQLSpeedRequester {
  public getHomeSpeedSummary = (startTimestamp: TimestampInMillis, endTimestamp: TimestampInMillis, intervalInDays: number, groupIds?: string[]): Promise<HomeSpeed> => {
    const timeZone = TimeZone.getTimezone();

    return graphQLRequester
      .query<{ homeSpeedSummary: HomeSpeed }>({
        query: gql`
          query GetHomeSpeedSummary(
            $begin: Float!
            $end: Float!
            $tz: String!
            $intervalInDays: Int!
            $groupIds: [String]
          ) {
            homeSpeedSummary(
              begin: $begin
              end: $end
              tz: $tz
              interval_in_days: $intervalInDays
              groupIds: $groupIds
            ) {
              roadEvents {
                mediumEvents
                highEvents
                higherEvents
                totalEvents
              }
              vehicleEvents {
                mediumEvents
                highEvents
                higherEvents
                totalEvents
              }
            }
          }
        `,
        variables: {
          begin: startTimestamp,
          end: endTimestamp,
          tz: timeZone,
          intervalInDays: intervalInDays,
          groupIds: groupIds,
        },
      })
      .then((graphQlResponse) => graphQlResponse.homeSpeedSummary);
  };
}

export default GrahpQLSpeedRequester;
